import * as Yup from 'yup'

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Formato inválido')
    .min(3, 'E-mail deve possuir no mínimo 3 caracteres')
    .max(50, 'E-mail deve possuir no máximo 50 caracteres')
    .required('E-mail é obrigatório'),
  password: Yup.string()
    .min(3, 'Senha deve possuir no mínimo 3 caracteres')
    .max(50, 'Senha deve possuir no máximo 50 caracteres')
    .required('Senha é obrigatória'),
})
